import {AbstractControl, ValidationErrors} from '@angular/forms';

export function confirmPasswordValidator(control: AbstractControl): ValidationErrors | null {
  if (control.get('password')?.value !== control.get('confirm')?.value) {
    control.get('confirm')?.setErrors({incorrect: true});
  } else {
    control.get('confirm')?.setErrors(null);
  }
  return null;
}
